/**
 * search page sagas
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/16
 */
import {takeLatest, call, put, all} from 'redux-saga/effects';
import {
  GET_SEARCH_TIP,
  GET_PRODUCT_BY_QUERY,
  receiveSearchTip,
  receiveQueryProduct
} from '../actions/search';
import * as searchService from '../services/search';
import { addDialog } from '../actions/app';
const SERVER_ERR = '服务器繁忙';

/**
 * get product data by query & page
 */
export function* getProductByQuery(action) {
  try {
    const resp = yield call(searchService.queryProduct, action.query, action.current);
    if (resp.success) {
      const product = { query: action.query, ...resp.data };
      product.current = action.current || 1;
      yield put(receiveQueryProduct(product));
    } else {
      yield put(addDialog(SERVER_ERR));
    }
  } catch (e) {
    yield put(addDialog());
    console.error(`SAGAS_SEARCH_QUERYPRODUCT ERROR: ${e.stack}`);
  }
}

export function* getSearchTip(action) {
  try {
    const resp = yield call(searchService.getSearchTip, action.query);
    if (resp.success) {
      yield put(receiveSearchTip(resp.data));
    } else {
      yield put(addDialog(SERVER_ERR));
    }
  } catch (e) {
    yield put(addDialog());
    console.error(`SAGAS_SEARCH_SEARCHTIP ERROR: ${e.stack}`);
  }
}

export function* watchSearch() {
  // yield takeLatest(GET_PRODUCT_BY_QUERY, getProductByQuery);
  yield all([
    takeLatest(GET_PRODUCT_BY_QUERY, getProductByQuery),
    takeLatest(GET_SEARCH_TIP, getSearchTip)
  ]);
}


// WEBPACK FOOTER //
// ./src/sagas/search.js